import React from 'react';
import { observer } from 'mobx-react';
import { StringStore } from 'ui/base/input/store';
import { TextAreaChangeEvent, TextAreaProps } from 'ui/base/types';

export type TextAreaInputProps = Omit<TextAreaProps, 'type' | 'value' | 'onChange'> & {
  store: StringStore;
};

export const TextAreaInput = observer(({ store, ...props }: TextAreaInputProps) => {
  const onChange = React.useCallback((event: TextAreaChangeEvent) => {
    store.setValue(event.target.value);
  }, [store]);

  return <textarea value={store.value} onChange={onChange} {...props}/>;
});
